// assets/progress-bar.js (REPLACE with this robust normalizer)
(function(){
  'use strict';

  // safe parse -> returns integer (no decimals)
  function parseIntSafe(val) {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return Math.floor(val);
    var cleaned = String(val).replace(/[^\d\-]/g, '');
    return cleaned === '' ? 0 : parseInt(cleaned, 10);
  }

  // Heuristic normalizer: Shopify uses cents/paise. If value looks like rupees (small),
  // convert to paise by multiplying by 100. We use thresholds to decide.
  function normalizeToCents(value) {
    var n = parseIntSafe(value);
    // If value looks suspiciously small (<= 10000) it might be in rupees:
    // - 10,000 paise = ₹100,  so if n <= 10000 it's ambiguous.
    // We use a safer threshold: if n < 1000 treat as rupees (i.e. < ₹10) - but that's too small.
    // Better approach: if n < 10000 AND no decimals in original string, assume it's rupees.
    // We'll use multiple checks:
    if (n === 0) return 0;

    // If number is less than 1000 -> almost certainly rupees (<= ₹10), convert.
    if (n < 1000) {
      return n * 100;
    }

    // If number is between 1000 and 20000 -> ambiguous. We'll try to detect presence of decimal in original string:
    // (But we don't have original string here if number passed already numeric).
    // Use heuristic: if it's <= 20000 (<= ₹200) and not a multiple of 100 => likely rupees (e.g., 485 is rupees).
    if (n > 1000 && n < 20000 && (n % 100 !== 0)) {
      return n * 100;
    }

    // If n looks like already paise (multiple of 100 or > 20000) return as-is.
    return n;
  }

  // Format cents/paise into rupee string (₹xxx)
  function formatMoneyFromCents(cents) {
    cents = parseIntSafe(cents);
    var rupees = (cents / 100).toFixed(2);
    if (rupees.indexOf('.00') !== -1) rupees = rupees.replace('.00','');
    return '₹' + rupees;
  }

  function readDataConfig() {
    var container = document.getElementById('gift-progress');
    if (!container) return null;

    var thresholdsJson = container.getAttribute('data-thresholds') || '[]';
    var thresholds;
    try {
      thresholds = JSON.parse(thresholdsJson);
    } catch (e) {
      console.warn('gift-progress: thresholds JSON parse failed, using defaults', e);
      thresholds = [
        {amount:200000,gift:200},
        {amount:400000,gift:500},
        {amount:700000,gift:800},
        {amount:1000000,gift:1200}
      ];
    }

    // normalize thresholds amounts -> cents
    thresholds = thresholds.map(function(t){
      var rawAmount = t.amount;
      var rawGift = t.gift;
      var amountCents = normalizeToCents(rawAmount);
      var giftValue = parseIntSafe(rawGift); // gift value we show in rupees (no conversion)
      return {
        amount: amountCents,
        gift: giftValue
      };
    });

    // inline total (Liquid should have provided cents, but normalize just in case)
    var inlineTotalRaw = container.getAttribute('data-cart-total') || '0';
    var inlineTotal = normalizeToCents(inlineTotalRaw);

    return {
      container: container,
      thresholds: thresholds,
      inlineTotal: inlineTotal
    };
  }

  function updateProgress(totalRaw, config) {
    if (!config || !config.container) return;
    var container = config.container;
    var thresholds = config.thresholds;
    var msgEl = container.querySelector('#gift-progress-message') || container.querySelector('.gift-progress__message');
    var barFill = container.querySelector('.gift-progress__bar-fill');

    // normalize incoming total (could be cart.total_price or inline)
    var total = normalizeToCents(totalRaw);

    // find next threshold
    var next = null;
    var nextGift = 0;
    for (var i=0;i<thresholds.length;i++){
      if (total < thresholds[i].amount) {
        next = thresholds[i].amount;
        nextGift = thresholds[i].gift;
        break;
      }
    }

    var maxAmount = thresholds.length ? thresholds[thresholds.length - 1].amount : 1;
    var pct = Math.min(100, Math.round((total / maxAmount) * 100));
    if (barFill) barFill.style.width = pct + '%';

    if (msgEl) {
      if (next) {
        var remaining = next - total;
        // remaining is in cents now. Format correctly.
        msgEl.innerHTML = 'Spend <strong>' + formatMoneyFromCents(remaining) + '</strong> more to get a gift worth <strong>₹' + nextGift + '</strong>.';
      } else {
        msgEl.innerHTML = 'Congratulations — you qualify for the highest gift of <strong>₹' + (thresholds.length ? thresholds[thresholds.length-1].gift : '') + '</strong>!';
      }
    }

    // update markers
    var markers = container.querySelectorAll('.gift-progress__marker');
    Array.prototype.forEach.call(markers, function(m){
      var tRaw = m.getAttribute('data-threshold');
      var t = normalizeToCents(tRaw);
      var dot = m.querySelector('.gift-progress__marker-dot');
      if (!dot) return;
      if (total >= t) dot.style.background = '#2e8b2e'; else dot.style.background = '#ddd';
    });

    // debug logs (comment out when satisfied)
    if (window.console && window.console.log) {
      console.log('gift-progress normalized:', {
        total_raw: totalRaw,
        total_cents: total,
        thresholds: thresholds,
        percent: pct,
        next_threshold_cents: next,
        next_gift_rupees: nextGift
      });
    }
  }

  function fetchCartAndUpdate(config) {
    if (!config) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(res){ return res.json(); })
      .then(function(cart){
        // cart.total_price should be paise, but normalize anyway
        updateProgress(cart.total_price, config);
      })
      .catch(function(err){
        console.warn('gift-progress: /cart.js fetch failed, falling back to inline total', err);
        updateProgress(config.inlineTotal, config);
      });
  }

  document.addEventListener('DOMContentLoaded', function(){
    var config = readDataConfig();
    if (!config) return;
    // initial render
    updateProgress(config.inlineTotal, config);
    // then authoritative fetch
    fetchCartAndUpdate(config);

    var refresh = function(){ fetchCartAndUpdate(config); };
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('theme:cart:updated', refresh);
    document.addEventListener('theme:cart:update', refresh);

    document.addEventListener('change', function(e){
      if (e.target && (e.target.matches('input[name="updates[]"]') || e.target.matches('.cart__qty') || e.target.matches('.js-qty'))) {
        setTimeout(function(){ fetchCartAndUpdate(config); }, 300);
      }
    }, true);

    document.addEventListener('click', function(e){
      var el = e.target;
      if (el && (el.matches('[data-add-to-cart]') || el.matches('[name="add"]') || el.closest('[data-add-to-cart]'))) {
        setTimeout(function(){ fetchCartAndUpdate(config); }, 700);
      }
    }, true);
  });
})();
